import { useEffect, useState } from "react";
import { heroImages, brand } from "../data/mock";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CAROUSEL_INTERVAL_MS = 5500;
const HERO_FADE_MS = 1600;
const HERO_ZOOM_MS = 8000;

export default function Hero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(
      () => setIdx((i) => (i + 1) % heroImages.length),
      CAROUSEL_INTERVAL_MS
    );
    return () => clearInterval(timer);
  }, []);
  // heroImages is a module-level constant; setIdx and CAROUSEL_INTERVAL_MS are stable — no deps needed.

  return (
    <section className="relative h-[100svh] w-full overflow-hidden">
      {heroImages.map((src, i) => (
        <div
          key={src}
          className={`absolute inset-0 transition-opacity ease-out ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
          style={{ transitionDuration: `${HERO_FADE_MS}ms` }}
        >
          <img
            src={src}
            alt="Elegant wedding"
            className="w-full h-full object-cover"
            style={{
              transform: i === idx ? "scale(1.06)" : "scale(1)",
              transition: `transform ${HERO_ZOOM_MS}ms ease-out`,
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-black/60" />
        </div>
      ))}

      <div className="relative z-10 h-full flex flex-col justify-between text-[hsl(var(--bg))]">
        <div className="pt-32 md:pt-40 text-center px-6">
          <div className="kicker text-white/85">{brand.intro}</div>
        </div>

        <div className="px-6 md:px-16 pb-24 md:pb-32 max-w-[1200px]">
          <h1 className="font-display text-[42px] leading-[1.05] md:text-[86px] md:leading-[0.98] tracking-tight">
            <span className="italic font-light">Design, Planning</span>
            <br />
            <span>&amp; Delivery of</span>
            <br />
            <span className="italic font-light">Exceptional Weddings</span>
            <br />
            <span>&amp; Events</span>
          </h1>
          <div className="mt-10">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 border border-white/80 hover:bg-white hover:text-[hsl(var(--ink))] transition-colors duration-500 px-6 py-3 text-[11px] tracking-[0.35em] uppercase"
            >
              Begin your journey <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 right-8 z-10 flex gap-2">
        {heroImages.map((src, i) => (
          <button
            key={`indicator-${src}`}
            onClick={() => setIdx(i)}
            aria-label={`slide-${i}`}
            className={`h-[2px] w-8 transition-colors ${i === idx ? "bg-white" : "bg-white/40"}`}
          />
        ))}
      </div>
    </section>
  );
}
